<template>
	<select v-if="loading" disabled ><option >Loading...</option></select>
	<select
		v-else
		ref="input"
		v-model="localVal"
		>
		<option v-for="(option,index) in org_options" :value="option.value" v-bind:selected="index===0" >{{ option.label }}</option>
	</select>
</template>

<script>

	export default {

		components : {
		},

		props : [
			'value',
			'required',
			],

		data(){
			return {
				localVal : this.value,
				orgs : [],
				loading : true,
			}
		},

		watch: {
			value : function(){
				this.localVal = this.value;
			},
			localVal : function(){
				this.$emit('input', this.localVal )
			},
			org_options : function(){
				if((this.localVal == undefined) && this.org_options.length){
					this.localVal = this.org_options[0].value;
				}
			},
		},

		computed:{
			org_options(){
				return this.orgs.map( t => ({label:t.personal?'Personal projects':t.name,value:t.id}));
			},
		},

		mounted(){
			var self = this;
			this.$store.dispatch('auth/refreshOrgs').then(function(orgs){
				self.orgs = orgs;
				self.loading = false;
			});
		},

		methods:{
			isSelected(option){

			},
		}
	}

</script>